import styled from 'styled-components';

export const Dropzone = styled.div`
  height: 154px;
  border: ${(props) =>
    props.active
      ? `2px dashed var(--ds-border, var(--ds-fb-border))`
      : `2px solid var(--ds-border, var(--ds-fb-border))`};
  text-align: center;
  position: relative;
  &:focus {
    border: 2px dashed var(--ds-border-focused, var(--ds-fb-border-focused));
    outline: none;
  }
`;

export const ActionText = styled.div`
  color: var(--ds-text-subtlest, var(--ds-text-subtlest));
  margin-bottom: 16px;
`;

export const Center = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Files = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  margin-left: 32px;
  align-items: center;
`;
